import { createFileRoute, redirect } from '@tanstack/react-router'

import { ROLES } from '@/entities/auth'
import { UsersPage } from '@/pages/users-page'

export const Route = createFileRoute('/_dashboard/users')({
    component: UsersPage,
    onEnter: () => {
        document.title = 'Taxoparkee - Пользователи'
    },
    beforeLoad: ({ context }) => {
        if (!context.auth.hasAnyRole([ROLES.superManager])) {
            throw redirect({
                to: '/recruitment',
                search: { page: 1 },
            })
        }
    },
})
